<template>
  <div class="details-view">
    <cargo-left-right-resize
      :show-left="warehouseInArr.length>1"
      :left-style="{ width: '15%',paddingTop:'10px' }"
      :right-style="{ width: '85%', }"
      style="min-height:100%"
    >
      <template slot="left">
        <el-card shadow="never">
          <div slot="header">
            <span>进仓编号</span>
          </div>
          <el-menu
            style="border:none"
            :default-active="warehouseInUuid"
          >
            <el-menu-item
              v-for="item in warehouseInArr"
              :key="item.uuid"
              :index="item.uuid"
              @click="()=>warehouseInUuid=item.uuid"
            >
              <span slot="title">{{ item.warehouseNo }}</span>
            </el-menu-item>
          </el-menu>
        </el-card>
      </template>
      <template
        slot="right"
      >
        <div class="main-content">
          <div
            v-show="!isLook"
            style="padding-left: 0px;"
          >
            <div class="triggers">
              <el-button
                type="primary"
                @click="editBack"
              >取消
              </el-button>
              <el-button
                type="primary"
                @click="doSave"
              >保存
              </el-button>
            </div>
          </div>
          <div
            v-show="isLook"
            style="padding-left: 0px;"
          >
            <div class="triggers">
              <el-button
                type="success"
                @click="toBackList"
              >返回
              </el-button>
              <el-button
                type="primary"
                @click="showDetail(warehouseInUuid,3)"
              >编辑
              </el-button>
              <el-button
                type="danger"
                @click="handleDelOrder"
              >删除
              </el-button>
              <el-button
                type="primary"
                @click="onPrint"
              >打印
              </el-button>
              <el-button
                type="primary"
                @click="handleSplitOrder"
              >拆单
              </el-button>
              <el-button
                type="primary"
                @click="handleExportWarehouseInPackageDetail"
              >导出入仓箱单
              </el-button>
            </div>
          </div>
          <div
            class="tabs-container"
            style="margin-top: 5px"
          >
            <el-tabs
              v-model="activeTabName"
              type="card"
              style="width:100%"
            >
              <el-tab-pane
                label="基础信息"
                name="basic"
              >
                <base-info
                  ref="baseInfo"
                  :warehouse-in-uuid="warehouseInUuid"
                  :opration-type="oprationType"
                />
              </el-tab-pane>
            </el-tabs></div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>
<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import baseInfo from './baseInfo'
import {
  deleteWarehouseIn,
  saveWarehouseIn,
  splitWarehouseIn,
  exportWarehouseInPackageDetail
} from '@/api/OMS/warehouseIn'
import { getLoading } from '@/utils/utilBaseElement'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import convertResToBlob from '@/utils/convertResToBlob'

export default {
  name: 'WarehousingDetail',
  components: { cargoLeftRightResize, baseInfo, cargoTemplateSelectorDialog },
  data() {
    return {
      activeTabName: 'basic',
      warehouseInUuid: '',
      warehouseInArr: [],
      oprationType: 1,
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'WAREHOUSE',
        data: {
          WAREHOUSE_UUID: []
        }
      }
    }
  },
  computed: {
    isLook() {
      return this.oprationType !== 2 && this.oprationType !== 3
    }
  },
  methods: {
    editBack() {
      if (this.warehouseInUuid) {
        this.showDetail(this.warehouseInUuid, 1)
      } else {
        this.toBackList()
      }
    },
    showDetail(uuid, oprationType, selectedRow) {
      this.oprationType = oprationType
      if (uuid && typeof uuid !== 'string') {
        this.warehouseInUuid = selectedRow ? selectedRow.uuid : uuid[0].uuid
        this.warehouseInArr = uuid
      } else {
        this.warehouseInUuid = uuid
      }
    },
    toBackList() {
      this.warehouseInUuid = ''
      this.warehouseInArr = []
      this.$emit('backList')
    },
    handleDelOrder() {
      const item = this.$refs.baseInfo.warehouseInInfo
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, '进仓通知单:'),
          h('span', { style: 'margin: 0 10px' }, item.warehouseNo)
        ]),
        h('p', { style: 'color: red' }, '是否确定删除此进仓通知单?')
      ])
      this.$confirm(content, '删除进仓通知单', {
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        deleteWarehouseIn({ warehouseInUuid: item.uuid })
          .then((res) => {
            this.$message.success('删除成功')
            this.loading.close()
            this.toBackList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    doSave() {
      const params = { ...this.$refs.baseInfo.form, uuid: this.warehouseInUuid }

      this.loading = getLoading()
      saveWarehouseIn(params)
        .then((res) => {
          this.$message.success('保存成功')
          this.loading.close()
          if (this.oprationType === 2) {
            this.warehouseInUuid = res.data
          }
          this.oprationType = 1
        })
        .catch(() => {
          this.loading.close()
        })
    },
    handleSplitOrder() {
      const item = this.$refs.baseInfo.warehouseInInfo
      const packages = this.$refs.baseInfo.$refs.packageInfo.gridOptions.api
        .getSelectedRows()
        .filter((item) => {
          return item.packageNo
        })
      if (packages.length === 0) {
        this.showSplitOrderError('请先勾选包装，才可进行拆单。')
        return
      }
      this.splitOrderSubmit(item, packages)
    },
    showSplitOrderError(err) {
      const h = this.$createElement
      const content = h('div', null, [
        h('p', { style: 'color: red' }, err),
        h(
          'p',
          { style: 'color: gray' },
          '拆单：是指将部分包装拆分到新的进仓通知单中，而其他信息复制过去。'
        )
      ])
      this.$confirm(content, '提示', {
        type: 'error'
      })
    },
    splitOrderSubmit(item, packages) {
      const packageNos = packages.map((item) => item.packageNo)
      const packageUuids = packages.map((item) => item.uuid)
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, '包装号:'),
          h(
            'p',
            { style: 'margin: 0 10px;overflow-wrap: break-word;' },
            packageNos.join(',')
          )
        ]),
        h(
          'p',
          { style: 'color: red' },
          '是否确定将以上包装拆分到新的进仓通知单上？'
        ),
        h('p', { style: 'color: red' }, '注意:此操作不可逆，请谨慎操作。')
      ])
      this.$confirm(content, '拆分进仓通知单', {
        type: 'info'
      }).then(() => {
        this.loading = getLoading()
        splitWarehouseIn({
          warehouseInUuid: item.uuid,
          splitPoPackageList: packageUuids
        })
          .then((res) => {
            this.$message.success('拆单成功')
            this.loading.close()
            this.toBackList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    /**
     * 打印
     */
    onPrint() {
      const uids = [this.warehouseInUuid]
      if (uids.length > 0) {
        this.templateSelectorDialog.visible = true
        this.templateSelectorDialog.data = { WAREHOUSE_UUID: uids }
      }
    },
    handleExportWarehouseInPackageDetail() {
      this.loading = getLoading()
      exportWarehouseInPackageDetail({ warehouseInUuid: this.warehouseInUuid, templateName: 'CBCC' }).then(res => {
        convertResToBlob(res)
        this.$message.success('请求成功，正在导出！')
        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    }
  }
}
</script>
